import { render, staticRenderFns } from "./BookThumb.vue?vue&type=template&id=a8be030a&"
import script from "./BookThumb.vue?vue&type=script&lang=js&"
export * from "./BookThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports